export class Espedashboard{
  constructor(
    public _id: string,
    public title: string,
    public description: string,
    public services: string
  ){
  }
}
